export const paths = {
  home: '/',
  about: '/about',
  contact: '/contact',
  privacy: '/privacy-policy',
  servicesAnchor: '/#services',
  services: {
    tools: '/ai-tools',
    agents: '/ai-agents',
    migrations: '/data-migration',
    implementations: '/implementations',
    secureAi: '/secure-ai-environments',
  },
};

const legacyHtmlRedirects = [
  { to: paths.home, from: '/index.html' },
  { to: paths.about, from: '/o-nas.html' },
  { to: paths.contact, from: '/kontakt.html' },
  { from: '/wdrozenia.html', to: paths.services.implementations },
  { from: '/agenci-ai.html', to: paths.services.agents },
  { to: paths.services.tools, from: '/narzedzia-ai.html' },
  { from: '/migracje-danych.html', to: paths.services.migrations },
  { to: paths.privacy, from: '/polityka-prywatnosci.html' },
  { to: paths.services.secureAi, from: '/zamkniete-srodowiska-ai.html' },
];

const legacyPolishRedirects = [
  { from: '/o-nas', to: paths.about },
  { from: '/kontakt', to: paths.contact },
  { from: '/wdrozenia', to: paths.services.implementations },
  { from: '/agenci-ai', to: paths.services.agents },
  { from: '/narzedzia-ai', to: paths.services.tools },
  { from: '/migracje-danych', to: paths.services.migrations },
  { to: paths.privacy, from: '/polityka-prywatnosci' },
  { to: paths.services.secureAi, from: '/zamkniete-srodowiska-ai' },
];

export const legacyRedirects = [...legacyHtmlRedirects, ...legacyPolishRedirects];
